// TODO: Remove. This selector is pretty much useless.
// Previously we coupled the authentication and payment status
// to the services display responsibility which was horrible design
import _ from 'lodash';
import { createSelector } from 'reselect';

const services = state => state.services;

const getServicesMenuOptions = myServices => {
  if (myServices.status || _.isEmpty(myServices)) return { status: 'loading' };

  if (myServices.error) return { error: myServices.error };

  return {
    Language: _.sortBy(myServices, 'description'),
    Academic: []
  };
};

export default createSelector(
  // state selecting functions which are updated
  // whenever the global state changes
  services,
  // function containing selector logic
  getServicesMenuOptions
);



// WEBPACK FOOTER //
// ./src/selectors/ServicesMenuOptionsSelector.js